import styled from 'styled-components'

import { Color } from '../../theme/color'

interface ChipProps {
  $color?: 'white' | 'black'
  onClick?: () => void
  children: React.ReactNode
}
export function Chip({ children, $color = 'white', ...props }: ChipProps) {
  return (
    <StyleBadge $color={$color} {...props}>
      {children}
    </StyleBadge>
  )
}

const StyleBadge = styled.span<ChipProps>`
  display: inline-block;
  overflow: hidden;
  padding: 0 12px;
  border-radius: 50vh;
  font-size: 14px;
  line-height: 33px;
  cursor: pointer;
  ${({ $color }) => {
    const defaultStyles = `border: 1px solid ${Color.line}; background-color: ${Color.white}; font-weight: 500; color: ${Color.text_secondary};`

    if (typeof $color === 'undefined' || $color === 'white') {
      return defaultStyles
    }

    if ($color === 'black') {
      return `border: 1px solid ${Color.black}; background-color: ${Color.black}; font-weight: 700; color: ${Color.text_white};`
    }
  }};
`
